import styled from "styled-components";

export const Section = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 32,
  padding: "40px 48px",
  [`@media (max-width: 600px)`]: {
    padding: "32px 20px",
  },
}));

export const Title = styled("h2")(({ theme }) => ({
  fontSize: 28,
  fontWeight: 700,
  color: theme.palette.textPrimary,
  margin: 0,
  textAlign: "center",
  [`@media (max-width: 600px)`]: {
    fontSize: 22,
  },
}));

export const StatsGrid = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: 24,
  width: "100%",
  textAlign: "center",
  [`@media (max-width: 600px)`]: {
    gridTemplateColumns: "1fr",
    gap: 20,
  },
}));

export const StatNumber = styled("div")(({ theme }) => ({
  fontSize: 42,
  fontWeight: 700,
  color: theme.palette.primary,
  [`@media (max-width: 600px)`]: {
    fontSize: 32,
  },
}));

export const StatLabel = styled("div")(({ theme }) => ({
  fontSize: 16,
  color: theme.palette.textSecondary,
  marginTop: 4,
}));

export const Button = styled("button")(({ theme }) => ({
  border: "none",
  display: "inline-block",
  backgroundColor: theme.palette.primary,
  color: theme.palette.white,
  padding: "12px 32px",
  borderRadius: 8,
  fontSize: 16,
  fontWeight: 600,
  textDecoration: "none",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: theme.palette.primaryDark,
  },
}));
